<template src="./index.html"></template>

<script>
import { URL, apiCall } from "@/utils/api";
import mixin from "@/mixins/index";
export default {
  name: "AssestmentModal",
  mixins: [mixin],
  props: {
    visible: Boolean,
    selectedDOffice: Object,
    appeal: Object,
  },
  data() {
    return {
      modalVisible: false,
      submitLoading: false,
      fileList: [],
      assestmentButtons: [],
      selectedAssestment: null,
      assestmentNote: null,
      assestmentDialogTitle: null,
      action: URL[process.env.NODE_ENV].service_api + "files",
      startAgain: null,
      selectedAssestmentButton: null,
    };
  },
  methods: {
    saveAssestment() {
      if (!this.selectedAssestment || !this.selectedAssestmentButton) {
        this.$message.error("Zəhmət olmasa qiymətləndirmə statusu seçin");
        return;
      } else if (
        this.appeal &&
        this.selectedAssestmentButton.askForStartAgain &&
        this.startAgain == null
      ) {
        this.$message.error(
          "Zəhmət olmasa prosesin yenidən başlanması sualına cavab verin"
        );
        return;
      }
      this.submitLoading = true;
      let files = this.fileList.map((val) => {
        return val.response.data;
      });
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "assestments",
        method: "POST",
        data: {
          status: this.assestmentButtons.find(
            (item) => item.id == this.selectedAssestment
          ),
          note: this.assestmentNote,
          files: files,
          citizen: this.appeal ? { userId: this.appeal.citizen.userId } : null,
          officeDetail: this.selectedDOffice
            ? { id: this.selectedDOffice.id }
            : null,
          startAgain: this.appeal ? this.startAgain : null,
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.$message.success("Müraciət göndərildi.");
            this.submitLoading = false;
            this.$emit("save");
          } else {
            this.submitLoading = false;
            this.$message.error(response.data.error.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.submitLoading = false;
          this.$message.error(err.message);
        });
    },
    getAssestmentStatuses() {
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "common/assestmentStatuses/" +
          (this.appeal ? "citizen" : "user"),
        method: "GET",
      })
        .then((response) => {
          if (!response.data.error) this.assestmentButtons = response.data.data;
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleUploadChange({ fileList }) {
      //console.log(fileList);
      this.fileList = fileList;
    },
    handleAssestButtonChange(e) {
      this.selectedAssestmentButton = this.assestmentButtons.find(
        (item) => item.id == e.target.value
      );
      this.startAgain = null;
    },
    clearData() {
      this.startAgain = null;
      this.selectedAssestmentButton = null;
      this.assestmentNote = null;
      this.selectedAssestment = null;
      this.fileList = [];
    },
  },
  watch: {
    visible: function (newValue, oldValue) {
      this.modalVisible = this.visible;
      if (newValue && !oldValue) {
        this.getAssestmentStatuses();
        this.assestmentDialogTitle = this.selectedDOffice.problemSubOffices[0].office.name;
      }
    },
    modalVisible: function () {
      if (!this.modalVisible) {
        this.clearData();
        this.$emit("afterClose");
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
